export default __webpack_public_path__ + "static/media/FontAwesome5_Pro_Light.b1ad72ca.ttf";